<template>
  <div class="submission-tile" data-cy="submission-tile">
    <header class="submission-item__header">
      <span class="submission-name">
        <div @click="onTileClick">
          <span class="submission-tile__title" data-cy="submission-tile-title">
            <span
              class="submission-tile__title-status"
              :class="submission.Status"
            ></span>
            {{ submission.JobId }}</span
          >
          <span class="submission-type" data-cy="submission-type"
            >[{{ submission.JobType }}]</span
          >
        </div>
        <span class="task-list__card-info task-list__card-info--label">
          <div @click="onTileClick">
            <div data-cy="submission-by">
              Submitted By: {{ submission.UserLogin }} -
              {{ submission.UserEmail }}
            </div>
            <div data-cy="submission-date">
              Date:
              {{
                submission.DateProcessedForSort
                  ? new Date(submission.DateProcessedForSort).toLocaleString(
                      "en-US"
                    )
                  : ""
              }}
            </div>
            <div data-cy="submission-status">
              Status: {{ submission.Status }}
            </div>
            <div data-cy="submission-line-items">
              Total Items: {{ submission.LineItems }}
            </div>
          </div>
        </span>
      </span>
    </header>
  </div>
</template>

<script setup lang="ts">
import type { SubmissionsTable } from "@/Domain/SubmissionsTable";

const props = defineProps<{
  submission: SubmissionsTable;
}>();

const emit = defineEmits<{
  (event: "showDetails", submission: SubmissionsTable): void;
}>();

const onTileClick = function (e: MouseEvent) {
  const el = e.target as Element;
  if (!el) return;
  emit("showDetails", props.submission);
};
</script>

<style lang="scss">
.submission-tile {
  background: #fff;
  margin-bottom: 10px;
  border-radius: 4px;
  padding: 15px;
  cursor: pointer;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  display: block;

  &.__title {
    font: 16px/1.5 proxima-nova, sans-serif;
    color: #444955;
    background-color: #fff;
    font-weight: 400;
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
  }

  &__title-status {
    display: inline-block;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    margin-right: 5px;

    &.Approved,
    &.Certified,
    &.Kosher,
    &.Special,
    &.Closed {
      background: #6fc16f;
    }

    &.Pending,
    &.InProgress,
    &.Open,
    &.New,
    &.UnderReview {
      background: #fce300;
    }

    &.Allowed,
    &.NotAllowed,
    &.Terminated {
      background: red;
    }
  }

  .submission-type {
    display: inline-block;
    font-size: 12px;
    margin-left: 5px;
    color: #999;
  }

  .task-list__card-info--label {
    color: #a5a5a5;
    font-size: 12px;
    margin-top: 6px;
    display: block;

    .loc-download-container {
      display: flex;
      gap: 12px;
      margin-top: 12px;
    }

    .loc-dwnld {
      display: inline-flex;
      color: white;
      background: #33669a;
      padding: 5px 15px;
      align-items: center;
      text-decoration: none;

      svg {
        margin-right: 5px;
        fill: white;
      }
    }
  }

  .special-req-container {
    display: flex;
    gap: 12px;
  }

  .special-req-indicator {
    display: inline-block;
    margin-top: 5px;
    background: #666;
    color: white;
    font-size: 11px;
    padding: 3px 7px;
  }

  .submission-details {
    margin-top: 12px;

    .k-grid {
      border: 0;
    }

    .k-grid-header {
      display: none !important;
    }
  }
}
</style>
